'use client';
import { DynamicGameSections as GameSections } from '@/widgets/game-sections';
import { GamesPageShell } from '@/widgets/games-page-shell';
import type { PageMetadata } from '@/shared/hooks/usePageMetadata';

interface GamesProps {
  initialPageMetadata?: PageMetadata | null;
}

const Games = ({ initialPageMetadata = null }: GamesProps) => (
  <GamesPageShell
    initialPageMetadata={initialPageMetadata}
    renderSections={(openNotAllowedModal) => (
      <GameSections
        isGames={true}
        isMobileMenu={false}
        openNotAllowedModal={openNotAllowedModal}
      />
    )}
  />
);

export { Games };
